export default __webpack_public_path__ + "static/media/img-0121-france-full-face.1c63523a.png";